import { render, staticRenderFns } from "./IconRoundText.vue?vue&type=template&id=de34cca0&scoped=true"
import script from "./IconRoundText.vue?vue&type=script&lang=js"
export * from "./IconRoundText.vue?vue&type=script&lang=js"
import style0 from "./IconRoundText.vue?vue&type=style&index=0&id=de34cca0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de34cca0",
  null
  
)

export default component.exports